/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CatalogDTO,
  CatalogImportResult,
  CustomerDto,
  LicenseDto,
  PasswordResetRequest,
  PostAdminCatalogImportParams,
  PostAdminProjectCatalogImportParams,
  PostAdminTenantsTenantIdUsersUserIdRoleParams,
  ProjectCatalogDto,
  RegisterResponseDTO,
  RoleMatrixDto,
  RolePermissionDto,
  TenantAppRoleDto,
  TenantUserDto,
  UserDto,
  UserRoleAssignmentDto,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All Catalog
 */
export const getAdminCatalog = (signal?: AbortSignal) => {
  return customInstance<CatalogDTO[]>({
    url: `/admin/catalog`,
    method: "GET",
    signal,
  });
};

export const getGetAdminCatalogInfiniteQueryKey = () => {
  return ["infinite", `/admin/catalog`] as const;
};

export const getGetAdminCatalogQueryKey = () => {
  return [`/admin/catalog`] as const;
};

export const getGetAdminCatalogInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalog>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminCatalog>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCatalogInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCatalog>>> = ({
    signal,
  }) => getAdminCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalog>>
>;
export type GetAdminCatalogInfiniteQueryError = void;

export function useGetAdminCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalog>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Catalog
 */

export function useGetAdminCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCatalog>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAdminCatalog>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCatalogQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCatalog>>> = ({
    signal,
  }) => getAdminCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalog>>
>;
export type GetAdminCatalogQueryError = void;

export function useGetAdminCatalog<
  TData = Awaited<ReturnType<typeof getAdminCatalog>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalog<
  TData = Awaited<ReturnType<typeof getAdminCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalog<
  TData = Awaited<ReturnType<typeof getAdminCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Catalog
 */

export function useGetAdminCatalog<
  TData = Awaited<ReturnType<typeof getAdminCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Catalog
 */
export const postAdminCatalog = (
  catalogDTO: CatalogDTO,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogDTO>({
    url: `/admin/catalog`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: catalogDTO,
    signal,
  });
};

export const getPostAdminCatalogMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminCatalog>>,
    TError,
    { data: CatalogDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminCatalog>>,
  TError,
  { data: CatalogDTO },
  TContext
> => {
  const mutationKey = ["postAdminCatalog"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminCatalog>>,
    { data: CatalogDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postAdminCatalog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminCatalogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminCatalog>>
>;
export type PostAdminCatalogMutationBody = CatalogDTO;
export type PostAdminCatalogMutationError = void;

/**
 * @summary Create Catalog
 */
export const usePostAdminCatalog = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminCatalog>>,
      TError,
      { data: CatalogDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminCatalog>>,
  TError,
  { data: CatalogDTO },
  TContext
> => {
  const mutationOptions = getPostAdminCatalogMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Export Catalog
 */
export const getAdminCatalogExport = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/admin/catalog/export`,
    method: "GET",
    signal,
  });
};

export const getGetAdminCatalogExportInfiniteQueryKey = () => {
  return ["infinite", `/admin/catalog/export`] as const;
};

export const getGetAdminCatalogExportQueryKey = () => {
  return [`/admin/catalog/export`] as const;
};

export const getGetAdminCatalogExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogExport>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminCatalogExport>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCatalogExportInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCatalogExport>>
  > = ({ signal }) => getAdminCatalogExport(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalogExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalogExport>>
>;
export type GetAdminCatalogExportInfiniteQueryError = void;

export function useGetAdminCatalogExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogExport>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogExport>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogExport>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Catalog
 */

export function useGetAdminCatalogExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogExport>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogExportInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminCatalogExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCatalogExport>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCatalogExport>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCatalogExportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCatalogExport>>
  > = ({ signal }) => getAdminCatalogExport(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalogExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalogExport>>
>;
export type GetAdminCatalogExportQueryError = void;

export function useGetAdminCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminCatalogExport>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Catalog
 */

export function useGetAdminCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogExportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Import Catalog
 */
export const postAdminCatalogImport = (
  postAdminCatalogImportBody: string,
  params?: PostAdminCatalogImportParams,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogImportResult>({
    url: `/admin/catalog/import`,
    method: "POST",
    headers: { "Content-Type": "text/csv; charset=UTF-8" },
    data: postAdminCatalogImportBody,
    params,
    signal,
  });
};

export const getPostAdminCatalogImportMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminCatalogImport>>,
    TError,
    { data: string; params?: PostAdminCatalogImportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminCatalogImport>>,
  TError,
  { data: string; params?: PostAdminCatalogImportParams },
  TContext
> => {
  const mutationKey = ["postAdminCatalogImport"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminCatalogImport>>,
    { data: string; params?: PostAdminCatalogImportParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postAdminCatalogImport(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminCatalogImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminCatalogImport>>
>;
export type PostAdminCatalogImportMutationBody = string;
export type PostAdminCatalogImportMutationError = void;

/**
 * @summary Import Catalog
 */
export const usePostAdminCatalogImport = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminCatalogImport>>,
      TError,
      { data: string; params?: PostAdminCatalogImportParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminCatalogImport>>,
  TError,
  { data: string; params?: PostAdminCatalogImportParams },
  TContext
> => {
  const mutationOptions = getPostAdminCatalogImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Catalog
 */
export const putAdminCatalogId = (id: number, catalogDTO: CatalogDTO) => {
  return customInstance<CatalogDTO>({
    url: `/admin/catalog/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: catalogDTO,
  });
};

export const getPutAdminCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminCatalogId>>,
    TError,
    { id: number; data: CatalogDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminCatalogId>>,
  TError,
  { id: number; data: CatalogDTO },
  TContext
> => {
  const mutationKey = ["putAdminCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminCatalogId>>,
    { id: number; data: CatalogDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminCatalogId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminCatalogId>>
>;
export type PutAdminCatalogIdMutationBody = CatalogDTO;
export type PutAdminCatalogIdMutationError = void;

/**
 * @summary Update Catalog
 */
export const usePutAdminCatalogId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminCatalogId>>,
      TError,
      { id: number; data: CatalogDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminCatalogId>>,
  TError,
  { id: number; data: CatalogDTO },
  TContext
> => {
  const mutationOptions = getPutAdminCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Catalog By Id
 */
export const getAdminCatalogId = (id: number, signal?: AbortSignal) => {
  return customInstance<CatalogDTO>({
    url: `/admin/catalog/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminCatalogIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/catalog/${id}`] as const;
};

export const getGetAdminCatalogIdQueryKey = (id?: number) => {
  return [`/admin/catalog/${id}`] as const;
};

export const getGetAdminCatalogIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCatalogIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCatalogId>>
  > = ({ signal }) => getAdminCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalogId>>
>;
export type GetAdminCatalogIdInfiniteQueryError = void;

export function useGetAdminCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Catalog By Id
 */

export function useGetAdminCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminCatalogIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCatalogIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCatalogId>>
  > = ({ signal }) => getAdminCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCatalogIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCatalogId>>
>;
export type GetAdminCatalogIdQueryError = void;

export function useGetAdminCatalogId<
  TData = Awaited<ReturnType<typeof getAdminCatalogId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogId<
  TData = Awaited<ReturnType<typeof getAdminCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCatalogId<
  TData = Awaited<ReturnType<typeof getAdminCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Catalog By Id
 */

export function useGetAdminCatalogId<
  TData = Awaited<ReturnType<typeof getAdminCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCatalogIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Catalog
 */
export const deleteAdminCatalogId = (id: number) => {
  return customInstance<boolean>({
    url: `/admin/catalog/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminCatalogId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminCatalogId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminCatalogId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminCatalogId>>
>;

export type DeleteAdminCatalogIdMutationError = void;

/**
 * @summary Delete Catalog
 */
export const useDeleteAdminCatalogId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminCatalogId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create Customer
 */
export const postAdminCustomer = (
  customerDto: CustomerDto,
  signal?: AbortSignal,
) => {
  return customInstance<CustomerDto>({
    url: `/admin/customer`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: customerDto,
    signal,
  });
};

export const getPostAdminCustomerMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminCustomer>>,
    TError,
    { data: CustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminCustomer>>,
  TError,
  { data: CustomerDto },
  TContext
> => {
  const mutationKey = ["postAdminCustomer"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminCustomer>>,
    { data: CustomerDto }
  > = (props) => {
    const { data } = props ?? {};

    return postAdminCustomer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminCustomer>>
>;
export type PostAdminCustomerMutationBody = CustomerDto;
export type PostAdminCustomerMutationError = void;

/**
 * @summary Create Customer
 */
export const usePostAdminCustomer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminCustomer>>,
      TError,
      { data: CustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminCustomer>>,
  TError,
  { data: CustomerDto },
  TContext
> => {
  const mutationOptions = getPostAdminCustomerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Customer
 */
export const putAdminCustomerId = (id: number, customerDto: CustomerDto) => {
  return customInstance<CustomerDto>({
    url: `/admin/customer/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: customerDto,
  });
};

export const getPutAdminCustomerIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminCustomerId>>,
    TError,
    { id: number; data: CustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminCustomerId>>,
  TError,
  { id: number; data: CustomerDto },
  TContext
> => {
  const mutationKey = ["putAdminCustomerId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminCustomerId>>,
    { id: number; data: CustomerDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminCustomerId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminCustomerId>>
>;
export type PutAdminCustomerIdMutationBody = CustomerDto;
export type PutAdminCustomerIdMutationError = void;

/**
 * @summary Update Customer
 */
export const usePutAdminCustomerId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminCustomerId>>,
      TError,
      { id: number; data: CustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminCustomerId>>,
  TError,
  { id: number; data: CustomerDto },
  TContext
> => {
  const mutationOptions = getPutAdminCustomerIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Customer By Id
 */
export const getAdminCustomerId = (id: number, signal?: AbortSignal) => {
  return customInstance<CustomerDto>({
    url: `/admin/customer/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminCustomerIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/customer/${id}`] as const;
};

export const getGetAdminCustomerIdQueryKey = (id?: number) => {
  return [`/admin/customer/${id}`] as const;
};

export const getGetAdminCustomerIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCustomerIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCustomerId>>
  > = ({ signal }) => getAdminCustomerId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCustomerIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCustomerId>>
>;
export type GetAdminCustomerIdInfiniteQueryError = void;

export function useGetAdminCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomerId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Customer By Id
 */

export function useGetAdminCustomerIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomerId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCustomerIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminCustomerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCustomerIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCustomerId>>
  > = ({ signal }) => getAdminCustomerId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCustomerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCustomerId>>
>;
export type GetAdminCustomerIdQueryError = void;

export function useGetAdminCustomerId<
  TData = Awaited<ReturnType<typeof getAdminCustomerId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomerId<
  TData = Awaited<ReturnType<typeof getAdminCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomerId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomerId<
  TData = Awaited<ReturnType<typeof getAdminCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Customer By Id
 */

export function useGetAdminCustomerId<
  TData = Awaited<ReturnType<typeof getAdminCustomerId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomerId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCustomerIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Customer
 */
export const deleteAdminCustomerId = (id: number) => {
  return customInstance<boolean>({
    url: `/admin/customer/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminCustomerIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminCustomerId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminCustomerId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminCustomerId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminCustomerId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminCustomerId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminCustomerId>>
>;

export type DeleteAdminCustomerIdMutationError = void;

/**
 * @summary Delete Customer
 */
export const useDeleteAdminCustomerId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminCustomerId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminCustomerId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminCustomerIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All Customers
 */
export const getAdminCustomers = (signal?: AbortSignal) => {
  return customInstance<CustomerDto[]>({
    url: `/admin/customers`,
    method: "GET",
    signal,
  });
};

export const getGetAdminCustomersInfiniteQueryKey = () => {
  return ["infinite", `/admin/customers`] as const;
};

export const getGetAdminCustomersQueryKey = () => {
  return [`/admin/customers`] as const;
};

export const getGetAdminCustomersInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomers>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminCustomers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminCustomersInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCustomers>>
  > = ({ signal }) => getAdminCustomers(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminCustomers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCustomersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCustomers>>
>;
export type GetAdminCustomersInfiniteQueryError = void;

export function useGetAdminCustomersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomers>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Customers
 */

export function useGetAdminCustomersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminCustomers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCustomersInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminCustomers>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminCustomers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminCustomersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminCustomers>>
  > = ({ signal }) => getAdminCustomers(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminCustomers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminCustomers>>
>;
export type GetAdminCustomersQueryError = void;

export function useGetAdminCustomers<
  TData = Awaited<ReturnType<typeof getAdminCustomers>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomers<
  TData = Awaited<ReturnType<typeof getAdminCustomers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAdminCustomers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminCustomers<
  TData = Awaited<ReturnType<typeof getAdminCustomers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Customers
 */

export function useGetAdminCustomers<
  TData = Awaited<ReturnType<typeof getAdminCustomers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminCustomers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminCustomersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get All Licenses
 */
export const getAdminLicenses = (signal?: AbortSignal) => {
  return customInstance<LicenseDto[]>({
    url: `/admin/licenses`,
    method: "GET",
    signal,
  });
};

export const getGetAdminLicensesInfiniteQueryKey = () => {
  return ["infinite", `/admin/licenses`] as const;
};

export const getGetAdminLicensesQueryKey = () => {
  return [`/admin/licenses`] as const;
};

export const getGetAdminLicensesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicenses>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminLicenses>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminLicensesInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLicenses>>
  > = ({ signal }) => getAdminLicenses(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminLicenses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminLicensesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLicenses>>
>;
export type GetAdminLicensesInfiniteQueryError = void;

export function useGetAdminLicensesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicenses>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicenses>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicenses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicenses>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicenses>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicenses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicenses>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Licenses
 */

export function useGetAdminLicensesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicenses>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminLicensesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminLicensesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLicenses>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAdminLicenses>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminLicensesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLicenses>>
  > = ({ signal }) => getAdminLicenses(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLicenses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminLicensesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLicenses>>
>;
export type GetAdminLicensesQueryError = void;

export function useGetAdminLicenses<
  TData = Awaited<ReturnType<typeof getAdminLicenses>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicenses>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicenses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicenses<
  TData = Awaited<ReturnType<typeof getAdminLicenses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicenses>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicenses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicenses<
  TData = Awaited<ReturnType<typeof getAdminLicenses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Licenses
 */

export function useGetAdminLicenses<
  TData = Awaited<ReturnType<typeof getAdminLicenses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicenses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminLicensesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create License
 */
export const postAdminLicenses = (
  licenseDto: LicenseDto,
  signal?: AbortSignal,
) => {
  return customInstance<LicenseDto>({
    url: `/admin/licenses`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: licenseDto,
    signal,
  });
};

export const getPostAdminLicensesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminLicenses>>,
    TError,
    { data: LicenseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminLicenses>>,
  TError,
  { data: LicenseDto },
  TContext
> => {
  const mutationKey = ["postAdminLicenses"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminLicenses>>,
    { data: LicenseDto }
  > = (props) => {
    const { data } = props ?? {};

    return postAdminLicenses(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminLicensesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminLicenses>>
>;
export type PostAdminLicensesMutationBody = LicenseDto;
export type PostAdminLicensesMutationError = void;

/**
 * @summary Create License
 */
export const usePostAdminLicenses = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminLicenses>>,
      TError,
      { data: LicenseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminLicenses>>,
  TError,
  { data: LicenseDto },
  TContext
> => {
  const mutationOptions = getPostAdminLicensesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update License
 */
export const putAdminLicensesId = (id: number, licenseDto: LicenseDto) => {
  return customInstance<LicenseDto>({
    url: `/admin/licenses/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: licenseDto,
  });
};

export const getPutAdminLicensesIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminLicensesId>>,
    TError,
    { id: number; data: LicenseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminLicensesId>>,
  TError,
  { id: number; data: LicenseDto },
  TContext
> => {
  const mutationKey = ["putAdminLicensesId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminLicensesId>>,
    { id: number; data: LicenseDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminLicensesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminLicensesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminLicensesId>>
>;
export type PutAdminLicensesIdMutationBody = LicenseDto;
export type PutAdminLicensesIdMutationError = void;

/**
 * @summary Update License
 */
export const usePutAdminLicensesId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminLicensesId>>,
      TError,
      { id: number; data: LicenseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminLicensesId>>,
  TError,
  { id: number; data: LicenseDto },
  TContext
> => {
  const mutationOptions = getPutAdminLicensesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get License By Id
 */
export const getAdminLicensesId = (id: number, signal?: AbortSignal) => {
  return customInstance<LicenseDto>({
    url: `/admin/licenses/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminLicensesIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/licenses/${id}`] as const;
};

export const getGetAdminLicensesIdQueryKey = (id?: number) => {
  return [`/admin/licenses/${id}`] as const;
};

export const getGetAdminLicensesIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicensesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminLicensesIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLicensesId>>
  > = ({ signal }) => getAdminLicensesId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminLicensesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminLicensesIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLicensesId>>
>;
export type GetAdminLicensesIdInfiniteQueryError = void;

export function useGetAdminLicensesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicensesId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicensesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicensesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicensesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicensesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicensesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicensesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get License By Id
 */

export function useGetAdminLicensesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminLicensesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminLicensesIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminLicensesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLicensesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminLicensesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminLicensesId>>
  > = ({ signal }) => getAdminLicensesId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLicensesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminLicensesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminLicensesId>>
>;
export type GetAdminLicensesIdQueryError = void;

export function useGetAdminLicensesId<
  TData = Awaited<ReturnType<typeof getAdminLicensesId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicensesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicensesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesId<
  TData = Awaited<ReturnType<typeof getAdminLicensesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLicensesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLicensesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminLicensesId<
  TData = Awaited<ReturnType<typeof getAdminLicensesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get License By Id
 */

export function useGetAdminLicensesId<
  TData = Awaited<ReturnType<typeof getAdminLicensesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminLicensesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminLicensesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete License
 */
export const deleteAdminLicensesId = (id: number) => {
  return customInstance<boolean>({
    url: `/admin/licenses/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminLicensesIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminLicensesId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminLicensesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminLicensesId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminLicensesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminLicensesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminLicensesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminLicensesId>>
>;

export type DeleteAdminLicensesIdMutationError = void;

/**
 * @summary Delete License
 */
export const useDeleteAdminLicensesId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminLicensesId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminLicensesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminLicensesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All Project Catalog
 */
export const getAdminProjectCatalog = (signal?: AbortSignal) => {
  return customInstance<ProjectCatalogDto[]>({
    url: `/admin/project-catalog`,
    method: "GET",
    signal,
  });
};

export const getGetAdminProjectCatalogInfiniteQueryKey = () => {
  return ["infinite", `/admin/project-catalog`] as const;
};

export const getGetAdminProjectCatalogQueryKey = () => {
  return [`/admin/project-catalog`] as const;
};

export const getGetAdminProjectCatalogInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalog>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminProjectCatalog>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalog>>
  > = ({ signal }) => getAdminProjectCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalog>>
>;
export type GetAdminProjectCatalogInfiniteQueryError = void;

export function useGetAdminProjectCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalog>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Project Catalog
 */

export function useGetAdminProjectCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminProjectCatalogInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminProjectCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminProjectCatalog>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminProjectCatalog>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalog>>
  > = ({ signal }) => getAdminProjectCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalog>>
>;
export type GetAdminProjectCatalogQueryError = void;

export function useGetAdminProjectCatalog<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalog>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalog<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalog<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All Project Catalog
 */

export function useGetAdminProjectCatalog<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminProjectCatalogQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Project Catalog
 */
export const postAdminProjectCatalog = (
  projectCatalogDto: ProjectCatalogDto,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectCatalogDto>({
    url: `/admin/project-catalog`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: projectCatalogDto,
    signal,
  });
};

export const getPostAdminProjectCatalogMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminProjectCatalog>>,
    TError,
    { data: ProjectCatalogDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminProjectCatalog>>,
  TError,
  { data: ProjectCatalogDto },
  TContext
> => {
  const mutationKey = ["postAdminProjectCatalog"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminProjectCatalog>>,
    { data: ProjectCatalogDto }
  > = (props) => {
    const { data } = props ?? {};

    return postAdminProjectCatalog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminProjectCatalogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminProjectCatalog>>
>;
export type PostAdminProjectCatalogMutationBody = ProjectCatalogDto;
export type PostAdminProjectCatalogMutationError = void;

/**
 * @summary Create Project Catalog
 */
export const usePostAdminProjectCatalog = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminProjectCatalog>>,
      TError,
      { data: ProjectCatalogDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminProjectCatalog>>,
  TError,
  { data: ProjectCatalogDto },
  TContext
> => {
  const mutationOptions = getPostAdminProjectCatalogMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Export Project Catalog
 */
export const getAdminProjectCatalogExport = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/admin/project-catalog/export`,
    method: "GET",
    signal,
  });
};

export const getGetAdminProjectCatalogExportInfiniteQueryKey = () => {
  return ["infinite", `/admin/project-catalog/export`] as const;
};

export const getGetAdminProjectCatalogExportQueryKey = () => {
  return [`/admin/project-catalog/export`] as const;
};

export const getGetAdminProjectCatalogExportInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogExportInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  > = ({ signal }) => getAdminProjectCatalogExport(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
>;
export type GetAdminProjectCatalogExportInfiniteQueryError = void;

export function useGetAdminProjectCatalogExportInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogExportInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogExportInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Project Catalog
 */

export function useGetAdminProjectCatalogExportInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAdminProjectCatalogExportInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminProjectCatalogExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogExportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
  > = ({ signal }) => getAdminProjectCatalogExport(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
>;
export type GetAdminProjectCatalogExportQueryError = void;

export function useGetAdminProjectCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogExport>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Project Catalog
 */

export function useGetAdminProjectCatalogExport<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminProjectCatalogExportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Import Project Catalog
 */
export const postAdminProjectCatalogImport = (
  postAdminProjectCatalogImportBody: string,
  params?: PostAdminProjectCatalogImportParams,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogImportResult>({
    url: `/admin/project-catalog/import`,
    method: "POST",
    headers: { "Content-Type": "text/csv; charset=UTF-8" },
    data: postAdminProjectCatalogImportBody,
    params,
    signal,
  });
};

export const getPostAdminProjectCatalogImportMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminProjectCatalogImport>>,
    TError,
    { data: string; params?: PostAdminProjectCatalogImportParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminProjectCatalogImport>>,
  TError,
  { data: string; params?: PostAdminProjectCatalogImportParams },
  TContext
> => {
  const mutationKey = ["postAdminProjectCatalogImport"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminProjectCatalogImport>>,
    { data: string; params?: PostAdminProjectCatalogImportParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postAdminProjectCatalogImport(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminProjectCatalogImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminProjectCatalogImport>>
>;
export type PostAdminProjectCatalogImportMutationBody = string;
export type PostAdminProjectCatalogImportMutationError = void;

/**
 * @summary Import Project Catalog
 */
export const usePostAdminProjectCatalogImport = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminProjectCatalogImport>>,
      TError,
      { data: string; params?: PostAdminProjectCatalogImportParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminProjectCatalogImport>>,
  TError,
  { data: string; params?: PostAdminProjectCatalogImportParams },
  TContext
> => {
  const mutationOptions =
    getPostAdminProjectCatalogImportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Project Catalog
 */
export const putAdminProjectCatalogId = (
  id: number,
  projectCatalogDto: ProjectCatalogDto,
) => {
  return customInstance<ProjectCatalogDto>({
    url: `/admin/project-catalog/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: projectCatalogDto,
  });
};

export const getPutAdminProjectCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminProjectCatalogId>>,
    TError,
    { id: number; data: ProjectCatalogDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminProjectCatalogId>>,
  TError,
  { id: number; data: ProjectCatalogDto },
  TContext
> => {
  const mutationKey = ["putAdminProjectCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminProjectCatalogId>>,
    { id: number; data: ProjectCatalogDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminProjectCatalogId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminProjectCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminProjectCatalogId>>
>;
export type PutAdminProjectCatalogIdMutationBody = ProjectCatalogDto;
export type PutAdminProjectCatalogIdMutationError = void;

/**
 * @summary Update Project Catalog
 */
export const usePutAdminProjectCatalogId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminProjectCatalogId>>,
      TError,
      { id: number; data: ProjectCatalogDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminProjectCatalogId>>,
  TError,
  { id: number; data: ProjectCatalogDto },
  TContext
> => {
  const mutationOptions = getPutAdminProjectCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Project Catalog By Id
 */
export const getAdminProjectCatalogId = (id: number, signal?: AbortSignal) => {
  return customInstance<ProjectCatalogDto>({
    url: `/admin/project-catalog/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminProjectCatalogIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/admin/project-catalog/${id}`] as const;
};

export const getGetAdminProjectCatalogIdQueryKey = (id?: number) => {
  return [`/admin/project-catalog/${id}`] as const;
};

export const getGetAdminProjectCatalogIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalogId>>
  > = ({ signal }) => getAdminProjectCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalogId>>
>;
export type GetAdminProjectCatalogIdInfiniteQueryError = void;

export function useGetAdminProjectCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalogId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Project Catalog By Id
 */

export function useGetAdminProjectCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminProjectCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminProjectCatalogIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminProjectCatalogIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProjectCatalogIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProjectCatalogId>>
  > = ({ signal }) => getAdminProjectCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminProjectCatalogIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProjectCatalogId>>
>;
export type GetAdminProjectCatalogIdQueryError = void;

export function useGetAdminProjectCatalogId<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogId<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getAdminProjectCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminProjectCatalogId<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Project Catalog By Id
 */

export function useGetAdminProjectCatalogId<
  TData = Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminProjectCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminProjectCatalogIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Project Catalog
 */
export const deleteAdminProjectCatalogId = (id: number) => {
  return customInstance<boolean>({
    url: `/admin/project-catalog/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminProjectCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminProjectCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminProjectCatalogId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminProjectCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>
>;

export type DeleteAdminProjectCatalogIdMutationError = void;

/**
 * @summary Delete Project Catalog
 */
export const useDeleteAdminProjectCatalogId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminProjectCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAdminProjectCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get System Admins
 */
export const getAdminSystemAdmins = (signal?: AbortSignal) => {
  return customInstance<UserDto[]>({
    url: `/admin/system-admins`,
    method: "GET",
    signal,
  });
};

export const getGetAdminSystemAdminsInfiniteQueryKey = () => {
  return ["infinite", `/admin/system-admins`] as const;
};

export const getGetAdminSystemAdminsQueryKey = () => {
  return [`/admin/system-admins`] as const;
};

export const getGetAdminSystemAdminsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminSystemAdmins>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAdminSystemAdmins>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminSystemAdminsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSystemAdmins>>
  > = ({ signal }) => getAdminSystemAdmins(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminSystemAdmins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminSystemAdminsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSystemAdmins>>
>;
export type GetAdminSystemAdminsInfiniteQueryError = void;

export function useGetAdminSystemAdminsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminSystemAdmins>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemAdmins>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminSystemAdminsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminSystemAdmins>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemAdmins>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminSystemAdminsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminSystemAdmins>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get System Admins
 */

export function useGetAdminSystemAdminsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAdminSystemAdmins>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminSystemAdminsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminSystemAdminsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSystemAdmins>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAdminSystemAdmins>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminSystemAdminsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSystemAdmins>>
  > = ({ signal }) => getAdminSystemAdmins(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSystemAdmins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminSystemAdminsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSystemAdmins>>
>;
export type GetAdminSystemAdminsQueryError = void;

export function useGetAdminSystemAdmins<
  TData = Awaited<ReturnType<typeof getAdminSystemAdmins>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemAdmins>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminSystemAdmins<
  TData = Awaited<ReturnType<typeof getAdminSystemAdmins>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemAdmins>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminSystemAdmins<
  TData = Awaited<ReturnType<typeof getAdminSystemAdmins>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get System Admins
 */

export function useGetAdminSystemAdmins<
  TData = Awaited<ReturnType<typeof getAdminSystemAdmins>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminSystemAdmins>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminSystemAdminsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update System Admin
 */
export const putAdminSystemAdminsId = (id: number, userDto: UserDto) => {
  return customInstance<UserDto>({
    url: `/admin/system-admins/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: userDto,
  });
};

export const getPutAdminSystemAdminsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminSystemAdminsId>>,
    TError,
    { id: number; data: UserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminSystemAdminsId>>,
  TError,
  { id: number; data: UserDto },
  TContext
> => {
  const mutationKey = ["putAdminSystemAdminsId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminSystemAdminsId>>,
    { id: number; data: UserDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putAdminSystemAdminsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminSystemAdminsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminSystemAdminsId>>
>;
export type PutAdminSystemAdminsIdMutationBody = UserDto;
export type PutAdminSystemAdminsIdMutationError = void;

/**
 * @summary Update System Admin
 */
export const usePutAdminSystemAdminsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminSystemAdminsId>>,
      TError,
      { id: number; data: UserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminSystemAdminsId>>,
  TError,
  { id: number; data: UserDto },
  TContext
> => {
  const mutationOptions = getPutAdminSystemAdminsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Tenant Matrix
 */
export const getAdminTenantsTenantIdMatrix = (
  tenantId: string,
  signal?: AbortSignal,
) => {
  return customInstance<RoleMatrixDto>({
    url: `/admin/tenants/${tenantId}/matrix`,
    method: "GET",
    signal,
  });
};

export const getGetAdminTenantsTenantIdMatrixInfiniteQueryKey = (
  tenantId?: string,
) => {
  return ["infinite", `/admin/tenants/${tenantId}/matrix`] as const;
};

export const getGetAdminTenantsTenantIdMatrixQueryKey = (tenantId?: string) => {
  return [`/admin/tenants/${tenantId}/matrix`] as const;
};

export const getGetAdminTenantsTenantIdMatrixInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdMatrixInfiniteQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  > = ({ signal }) => getAdminTenantsTenantIdMatrix(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdMatrixInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
>;
export type GetAdminTenantsTenantIdMatrixInfiniteQueryError = void;

export function useGetAdminTenantsTenantIdMatrixInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  >,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdMatrixInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdMatrixInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Matrix
 */

export function useGetAdminTenantsTenantIdMatrixInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdMatrixInfiniteQueryOptions(
    tenantId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminTenantsTenantIdMatrixQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdMatrixQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
  > = ({ signal }) => getAdminTenantsTenantIdMatrix(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdMatrixQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
>;
export type GetAdminTenantsTenantIdMatrixQueryError = void;

export function useGetAdminTenantsTenantIdMatrix<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdMatrix<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdMatrix<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Matrix
 */

export function useGetAdminTenantsTenantIdMatrix<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdMatrixQueryOptions(
    tenantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Tenant Roles
 */
export const getAdminTenantsTenantIdRoles = (
  tenantId: string,
  signal?: AbortSignal,
) => {
  return customInstance<TenantAppRoleDto[]>({
    url: `/admin/tenants/${tenantId}/roles`,
    method: "GET",
    signal,
  });
};

export const getGetAdminTenantsTenantIdRolesInfiniteQueryKey = (
  tenantId?: string,
) => {
  return ["infinite", `/admin/tenants/${tenantId}/roles`] as const;
};

export const getGetAdminTenantsTenantIdRolesQueryKey = (tenantId?: string) => {
  return [`/admin/tenants/${tenantId}/roles`] as const;
};

export const getGetAdminTenantsTenantIdRolesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdRolesInfiniteQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  > = ({ signal }) => getAdminTenantsTenantIdRoles(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdRolesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
>;
export type GetAdminTenantsTenantIdRolesInfiniteQueryError = void;

export function useGetAdminTenantsTenantIdRolesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  >,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Roles
 */

export function useGetAdminTenantsTenantIdRolesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdRolesInfiniteQueryOptions(
    tenantId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminTenantsTenantIdRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminTenantsTenantIdRolesQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
  > = ({ signal }) => getAdminTenantsTenantIdRoles(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
>;
export type GetAdminTenantsTenantIdRolesQueryError = void;

export function useGetAdminTenantsTenantIdRoles<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRoles<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRoles<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Roles
 */

export function useGetAdminTenantsTenantIdRoles<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdRolesQueryOptions(
    tenantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Tenant Role
 */
export const postAdminTenantsTenantIdRoles = (
  tenantId: string,
  tenantAppRoleDto: TenantAppRoleDto,
  signal?: AbortSignal,
) => {
  return customInstance<TenantAppRoleDto>({
    url: `/admin/tenants/${tenantId}/roles`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tenantAppRoleDto,
    signal,
  });
};

export const getPostAdminTenantsTenantIdRolesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>,
    TError,
    { tenantId: string; data: TenantAppRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>,
  TError,
  { tenantId: string; data: TenantAppRoleDto },
  TContext
> => {
  const mutationKey = ["postAdminTenantsTenantIdRoles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>,
    { tenantId: string; data: TenantAppRoleDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return postAdminTenantsTenantIdRoles(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminTenantsTenantIdRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>
>;
export type PostAdminTenantsTenantIdRolesMutationBody = TenantAppRoleDto;
export type PostAdminTenantsTenantIdRolesMutationError = void;

/**
 * @summary Create Tenant Role
 */
export const usePostAdminTenantsTenantIdRoles = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>,
      TError,
      { tenantId: string; data: TenantAppRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdRoles>>,
  TError,
  { tenantId: string; data: TenantAppRoleDto },
  TContext
> => {
  const mutationOptions =
    getPostAdminTenantsTenantIdRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Tenant Role
 */
export const putAdminTenantsTenantIdRolesRoleId = (
  tenantId: string,
  roleId: number,
  tenantAppRoleDto: TenantAppRoleDto,
) => {
  return customInstance<TenantAppRoleDto>({
    url: `/admin/tenants/${tenantId}/roles/${roleId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: tenantAppRoleDto,
  });
};

export const getPutAdminTenantsTenantIdRolesRoleIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>,
    TError,
    { tenantId: string; roleId: number; data: TenantAppRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>,
  TError,
  { tenantId: string; roleId: number; data: TenantAppRoleDto },
  TContext
> => {
  const mutationKey = ["putAdminTenantsTenantIdRolesRoleId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>,
    { tenantId: string; roleId: number; data: TenantAppRoleDto }
  > = (props) => {
    const { tenantId, roleId, data } = props ?? {};

    return putAdminTenantsTenantIdRolesRoleId(tenantId, roleId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminTenantsTenantIdRolesRoleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>
>;
export type PutAdminTenantsTenantIdRolesRoleIdMutationBody = TenantAppRoleDto;
export type PutAdminTenantsTenantIdRolesRoleIdMutationError = void;

/**
 * @summary Update Tenant Role
 */
export const usePutAdminTenantsTenantIdRolesRoleId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>,
      TError,
      { tenantId: string; roleId: number; data: TenantAppRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleId>>,
  TError,
  { tenantId: string; roleId: number; data: TenantAppRoleDto },
  TContext
> => {
  const mutationOptions =
    getPutAdminTenantsTenantIdRolesRoleIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Tenant Role
 */
export const getAdminTenantsTenantIdRolesRoleId = (
  tenantId: string,
  roleId: number,
  signal?: AbortSignal,
) => {
  return customInstance<TenantAppRoleDto>({
    url: `/admin/tenants/${tenantId}/roles/${roleId}`,
    method: "GET",
    signal,
  });
};

export const getGetAdminTenantsTenantIdRolesRoleIdInfiniteQueryKey = (
  tenantId?: string,
  roleId?: number,
) => {
  return ["infinite", `/admin/tenants/${tenantId}/roles/${roleId}`] as const;
};

export const getGetAdminTenantsTenantIdRolesRoleIdQueryKey = (
  tenantId?: string,
  roleId?: number,
) => {
  return [`/admin/tenants/${tenantId}/roles/${roleId}`] as const;
};

export const getGetAdminTenantsTenantIdRolesRoleIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  >,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdRolesRoleIdInfiniteQueryKey(tenantId, roleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  > = ({ signal }) =>
    getAdminTenantsTenantIdRolesRoleId(tenantId, roleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(tenantId && roleId),
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdRolesRoleIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
>;
export type GetAdminTenantsTenantIdRolesRoleIdInfiniteQueryError = void;

export function useGetAdminTenantsTenantIdRolesRoleIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  >,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesRoleIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  >,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesRoleIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  >,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Role
 */

export function useGetAdminTenantsTenantIdRolesRoleIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  >,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAdminTenantsTenantIdRolesRoleIdInfiniteQueryOptions(
      tenantId,
      roleId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminTenantsTenantIdRolesRoleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdRolesRoleIdQueryKey(tenantId, roleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
  > = ({ signal }) =>
    getAdminTenantsTenantIdRolesRoleId(tenantId, roleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(tenantId && roleId),
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdRolesRoleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
>;
export type GetAdminTenantsTenantIdRolesRoleIdQueryError = void;

export function useGetAdminTenantsTenantIdRolesRoleId<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesRoleId<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdRolesRoleId<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Role
 */

export function useGetAdminTenantsTenantIdRolesRoleId<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
  TError = void,
>(
  tenantId: string,
  roleId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdRolesRoleId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdRolesRoleIdQueryOptions(
    tenantId,
    roleId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Tenant Role
 */
export const deleteAdminTenantsTenantIdRolesRoleId = (
  tenantId: string,
  roleId: number,
) => {
  return customInstance<boolean>({
    url: `/admin/tenants/${tenantId}/roles/${roleId}`,
    method: "DELETE",
  });
};

export const getDeleteAdminTenantsTenantIdRolesRoleIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>,
    TError,
    { tenantId: string; roleId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>,
  TError,
  { tenantId: string; roleId: number },
  TContext
> => {
  const mutationKey = ["deleteAdminTenantsTenantIdRolesRoleId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>,
    { tenantId: string; roleId: number }
  > = (props) => {
    const { tenantId, roleId } = props ?? {};

    return deleteAdminTenantsTenantIdRolesRoleId(tenantId, roleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminTenantsTenantIdRolesRoleIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>
>;

export type DeleteAdminTenantsTenantIdRolesRoleIdMutationError = void;

/**
 * @summary Delete Tenant Role
 */
export const useDeleteAdminTenantsTenantIdRolesRoleId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>,
      TError,
      { tenantId: string; roleId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminTenantsTenantIdRolesRoleId>>,
  TError,
  { tenantId: string; roleId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAdminTenantsTenantIdRolesRoleIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Tenant Role Permissions
 */
export const putAdminTenantsTenantIdRolesRoleIdPermissions = (
  tenantId: string,
  roleId: number,
  rolePermissionDto: RolePermissionDto[],
) => {
  return customInstance<RolePermissionDto[]>({
    url: `/admin/tenants/${tenantId}/roles/${roleId}/permissions`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: rolePermissionDto,
  });
};

export const getPutAdminTenantsTenantIdRolesRoleIdPermissionsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>,
    TError,
    { tenantId: string; roleId: number; data: RolePermissionDto[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>,
  TError,
  { tenantId: string; roleId: number; data: RolePermissionDto[] },
  TContext
> => {
  const mutationKey = ["putAdminTenantsTenantIdRolesRoleIdPermissions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>,
    { tenantId: string; roleId: number; data: RolePermissionDto[] }
  > = (props) => {
    const { tenantId, roleId, data } = props ?? {};

    return putAdminTenantsTenantIdRolesRoleIdPermissions(
      tenantId,
      roleId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAdminTenantsTenantIdRolesRoleIdPermissionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>
  >;
export type PutAdminTenantsTenantIdRolesRoleIdPermissionsMutationBody =
  RolePermissionDto[];
export type PutAdminTenantsTenantIdRolesRoleIdPermissionsMutationError = void;

/**
 * @summary Update Tenant Role Permissions
 */
export const usePutAdminTenantsTenantIdRolesRoleIdPermissions = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>,
      TError,
      { tenantId: string; roleId: number; data: RolePermissionDto[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAdminTenantsTenantIdRolesRoleIdPermissions>>,
  TError,
  { tenantId: string; roleId: number; data: RolePermissionDto[] },
  TContext
> => {
  const mutationOptions =
    getPutAdminTenantsTenantIdRolesRoleIdPermissionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Tenant Users
 */
export const getAdminTenantsTenantIdUsers = (
  tenantId: string,
  signal?: AbortSignal,
) => {
  return customInstance<TenantUserDto[]>({
    url: `/admin/tenants/${tenantId}/users`,
    method: "GET",
    signal,
  });
};

export const getGetAdminTenantsTenantIdUsersInfiniteQueryKey = (
  tenantId?: string,
) => {
  return ["infinite", `/admin/tenants/${tenantId}/users`] as const;
};

export const getGetAdminTenantsTenantIdUsersQueryKey = (tenantId?: string) => {
  return [`/admin/tenants/${tenantId}/users`] as const;
};

export const getGetAdminTenantsTenantIdUsersInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAdminTenantsTenantIdUsersInfiniteQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  > = ({ signal }) => getAdminTenantsTenantIdUsers(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdUsersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
>;
export type GetAdminTenantsTenantIdUsersInfiniteQueryError = void;

export function useGetAdminTenantsTenantIdUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  >,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Users
 */

export function useGetAdminTenantsTenantIdUsersInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  >,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdUsersInfiniteQueryOptions(
    tenantId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAdminTenantsTenantIdUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminTenantsTenantIdUsersQueryKey(tenantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
  > = ({ signal }) => getAdminTenantsTenantIdUsers(tenantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAdminTenantsTenantIdUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
>;
export type GetAdminTenantsTenantIdUsersQueryError = void;

export function useGetAdminTenantsTenantIdUsers<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
  TError = void,
>(
  tenantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdUsers<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAdminTenantsTenantIdUsers<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Users
 */

export function useGetAdminTenantsTenantIdUsers<
  TData = Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
  TError = void,
>(
  tenantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminTenantsTenantIdUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAdminTenantsTenantIdUsersQueryOptions(
    tenantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Tenant User
 */
export const postAdminTenantsTenantIdUsers = (
  tenantId: string,
  userDto: UserDto,
  signal?: AbortSignal,
) => {
  return customInstance<RegisterResponseDTO>({
    url: `/admin/tenants/${tenantId}/users`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userDto,
    signal,
  });
};

export const getPostAdminTenantsTenantIdUsersMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>,
    TError,
    { tenantId: string; data: UserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>,
  TError,
  { tenantId: string; data: UserDto },
  TContext
> => {
  const mutationKey = ["postAdminTenantsTenantIdUsers"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>,
    { tenantId: string; data: UserDto }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return postAdminTenantsTenantIdUsers(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminTenantsTenantIdUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>
>;
export type PostAdminTenantsTenantIdUsersMutationBody = UserDto;
export type PostAdminTenantsTenantIdUsersMutationError = void;

/**
 * @summary Create Tenant User
 */
export const usePostAdminTenantsTenantIdUsers = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>,
      TError,
      { tenantId: string; data: UserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsers>>,
  TError,
  { tenantId: string; data: UserDto },
  TContext
> => {
  const mutationOptions =
    getPostAdminTenantsTenantIdUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unassign Role
 */
export const deleteAdminTenantsTenantIdUsersUserIdRole = (
  tenantId: string,
  userId: number,
) => {
  return customInstance<boolean>({
    url: `/admin/tenants/${tenantId}/users/${userId}/role`,
    method: "DELETE",
  });
};

export const getDeleteAdminTenantsTenantIdUsersUserIdRoleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>,
    TError,
    { tenantId: string; userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>,
  TError,
  { tenantId: string; userId: number },
  TContext
> => {
  const mutationKey = ["deleteAdminTenantsTenantIdUsersUserIdRole"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>,
    { tenantId: string; userId: number }
  > = (props) => {
    const { tenantId, userId } = props ?? {};

    return deleteAdminTenantsTenantIdUsersUserIdRole(tenantId, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminTenantsTenantIdUsersUserIdRoleMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>
  >;

export type DeleteAdminTenantsTenantIdUsersUserIdRoleMutationError = void;

/**
 * @summary Unassign Role
 */
export const useDeleteAdminTenantsTenantIdUsersUserIdRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>,
      TError,
      { tenantId: string; userId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminTenantsTenantIdUsersUserIdRole>>,
  TError,
  { tenantId: string; userId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteAdminTenantsTenantIdUsersUserIdRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Assign Role To User
 */
export const postAdminTenantsTenantIdUsersUserIdRole = (
  tenantId: string,
  userId: number,
  params?: PostAdminTenantsTenantIdUsersUserIdRoleParams,
  signal?: AbortSignal,
) => {
  return customInstance<UserRoleAssignmentDto>({
    url: `/admin/tenants/${tenantId}/users/${userId}/role`,
    method: "POST",
    params,
    signal,
  });
};

export const getPostAdminTenantsTenantIdUsersUserIdRoleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>,
    TError,
    {
      tenantId: string;
      userId: number;
      params?: PostAdminTenantsTenantIdUsersUserIdRoleParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>,
  TError,
  {
    tenantId: string;
    userId: number;
    params?: PostAdminTenantsTenantIdUsersUserIdRoleParams;
  },
  TContext
> => {
  const mutationKey = ["postAdminTenantsTenantIdUsersUserIdRole"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>,
    {
      tenantId: string;
      userId: number;
      params?: PostAdminTenantsTenantIdUsersUserIdRoleParams;
    }
  > = (props) => {
    const { tenantId, userId, params } = props ?? {};

    return postAdminTenantsTenantIdUsersUserIdRole(tenantId, userId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminTenantsTenantIdUsersUserIdRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>
>;

export type PostAdminTenantsTenantIdUsersUserIdRoleMutationError = void;

/**
 * @summary Assign Role To User
 */
export const usePostAdminTenantsTenantIdUsersUserIdRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>,
      TError,
      {
        tenantId: string;
        userId: number;
        params?: PostAdminTenantsTenantIdUsersUserIdRoleParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminTenantsTenantIdUsersUserIdRole>>,
  TError,
  {
    tenantId: string;
    userId: number;
    params?: PostAdminTenantsTenantIdUsersUserIdRoleParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostAdminTenantsTenantIdUsersUserIdRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete User
 */
export const deleteAdminUsersId = (id: number) => {
  return customInstance<boolean>({
    url: `/admin/users/${id}`,
    method: "DELETE",
  });
};

export const getDeleteAdminUsersIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminUsersId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminUsersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminUsersId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminUsersId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminUsersId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminUsersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminUsersId>>
>;

export type DeleteAdminUsersIdMutationError = void;

/**
 * @summary Delete User
 */
export const useDeleteAdminUsersId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAdminUsersId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminUsersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteAdminUsersIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reset Tenant User Password
 */
export const postAdminUsersIdPassword = (
  id: number,
  passwordResetRequest: PasswordResetRequest,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>({
    url: `/admin/users/${id}/password`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: passwordResetRequest,
    signal,
  });
};

export const getPostAdminUsersIdPasswordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminUsersIdPassword>>,
    TError,
    { id: number; data: PasswordResetRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminUsersIdPassword>>,
  TError,
  { id: number; data: PasswordResetRequest },
  TContext
> => {
  const mutationKey = ["postAdminUsersIdPassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminUsersIdPassword>>,
    { id: number; data: PasswordResetRequest }
  > = (props) => {
    const { id, data } = props ?? {};

    return postAdminUsersIdPassword(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminUsersIdPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminUsersIdPassword>>
>;
export type PostAdminUsersIdPasswordMutationBody = PasswordResetRequest;
export type PostAdminUsersIdPasswordMutationError = void;

/**
 * @summary Reset Tenant User Password
 */
export const usePostAdminUsersIdPassword = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminUsersIdPassword>>,
      TError,
      { id: number; data: PasswordResetRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminUsersIdPassword>>,
  TError,
  { id: number; data: PasswordResetRequest },
  TContext
> => {
  const mutationOptions = getPostAdminUsersIdPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
